
import { Component } from '@angular/core';
import { RestorerStats, SeagrassRestorerService } from '@spotter/services/restorer/seagrass-restorer.service';
import { LogoSliderComponent } from '../../shared/logo-slider/logo-slider.component';
import { FrontPageWidget } from '@spottercomponents/widgets/front-page/front-page.widget'

@Component({
    selector: 'app-home',
    templateUrl: './home.page.html',
    styleUrl: './home.page.scss',
    imports: [LogoSliderComponent, FrontPageWidget]
})
export class HomePage {

    stats?: RestorerStats;

    logos: string[] = [
        '/assets/images/logos/founding-partners/groningen.png',
        '/assets/images/logos/founding-partners/dalhouse.png',
        '/assets/images/logos/founding-partners/deakin.png',
        '/assets/images/logos/founding-partners/swansea.png',
        '/assets/images/logos/founding-partners/stellenbosch.png',
        '/assets/images/logos/founding-partners/ualg.png',
        '/assets/images/logos/founding-partners/aveiro.png',
        '/assets/images/logos/founding-partners/gothenburg.png',
        '/assets/images/logos/founding-partners/ps.png',
        '/assets/images/logos/founding-partners/cq.png',
        '/assets/images/logos/founding-partners/hu.png',
    ];

    constructor(restorer: SeagrassRestorerService) {
        restorer.stats().then(s => {
            this.stats = s;
            console.log(s);

        });
    }

}
